import { chain } from 'lodash';

import { PartnerCompanyTypes } from '~globals/types/enums';
import { COMPANY_TYPE_INFO } from '~constants/companyTypesInfo';

export const getCompanyTypeFieldLabel = (
  companyTypeId: PartnerCompanyTypes,
): string =>
  chain(COMPANY_TYPE_INFO).find({ companyTypeId }).get('label', '').value();
